import React from "react";

export default function InfoCircle() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21">
            <g fill="none" fillRule="evenodd">
                <g>
                    <g>
                        <g transform="translate(-319 -658) translate(24 646) translate(296 12)">
                            <circle cx="9.5" cy="10.167" r="9.5" stroke="#202B34" />
                            <text fill="#202B34" fontSize="12" fontWeight="500">
                                <tspan x="7.667" y="14.5">
                                    i
                                </tspan>
                            </text>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
